import React from "react";
import { useSelector } from "react-redux";
import OpenWalletProcessingModal from "./OpenWalletProcessingModal";
import OpenWalletSuccessModal from "./OpenWalletSuccessModal";

const WalletReadyModal = ({ isOpen, onClose, wallet }) => {
    const { business, wallets: storeWallets } = useSelector((state) => state);
    if (!isOpen || !wallet) return null;

    const currency = String(wallet?.currency || "").toUpperCase();
    const isCrypto = ["USDC", "USDT"].includes(currency);

    const raw = Array.isArray(storeWallets)
        ? storeWallets.find((w) => String(w?.currency).toUpperCase() === currency)
        : null;

    const providers = Array.isArray(raw?.providers) ? raw.providers : [];
    const provider =
        providers.find((p) => (isCrypto ? p?.address || p?.depositAddress : p?.accountNumber)) ||
        providers[0] ||
        {};

    const accountName = !isCrypto
      ? wallet?.accountName || provider?.accountName || business?.name || "-"
        : business?.name || "-";
    const accountNumber = !isCrypto
      ? wallet?.accountNumber || provider?.accountNumber || provider?.iban || provider?.account_no || ""
        : "";
    const bankName = !isCrypto
      ? wallet?.bankName || provider?.bankName || provider?.bank || provider?.bank_name || "Tradevu Wallet"
        : "";
  const sortCode = !isCrypto
    ? wallet?.sortCode || provider?.sortCode || provider?.sort_code || ""
    : "";
  const routingNumber = !isCrypto
    ? wallet?.routingNumber || provider?.routingNumber || provider?.routing_number || ""
    : "";
  const iban = !isCrypto
    ? wallet?.iban || provider?.iban || ""
    : "";
  const address = isCrypto
    ? wallet?.address || provider?.address || provider?.depositAddress || ""
    : "";

  const fiatDetailsReady = !!accountNumber;
  const providerPending = String(provider?.status || wallet?.providerStatus || "").toLowerCase() === "pending";
  const showReviewReceipt = Boolean(wallet?.review || (!isCrypto && (!fiatDetailsReady || providerPending)));

  if (showReviewReceipt) {
    return (
      <OpenWalletProcessingModal
        isOpen={isOpen}
        currencyCode={currency}
        onClose={onClose}
        onBackToDashboard={onClose}
      />
    );
  }

  return (
    <OpenWalletSuccessModal
      isOpen={isOpen}
      currencyCode={currency}
      walletDetails={{
        currency,
        accountName,
        accountNumber,
        bankName,
        sortCode,
        routingNumber,
        iban,
        address,
        businessName: business?.name,
      }}
      onClose={onClose}
      onBackToDashboard={onClose}
    />
    );
};

export default WalletReadyModal;
